/* ------------------------------------------------------------------ */
/* Singleton Firebase client – browser only                            */
/* ------------------------------------------------------------------ */
import { initializeApp, getApps } from "firebase/app";
import { getAuth, browserSessionPersistence, setPersistence } from "firebase/auth";
import { getMessaging, isSupported, Messaging } from "firebase/messaging";

import { firebaseConfig } from "@/lib/firebase/config";

/* ---------- init (once) ---------- */
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

/* ---------- auth singleton ---------- */
export const auth = getAuth(app);

/* ---------- messaging singleton (lazy) ---------- */
let messagingPromise: Promise<Messaging | null> | null = null;

/** Call once and cache the result */
export function getMessagingInstance(): Promise<Messaging | null> {
  if (!messagingPromise) {
    messagingPromise = isSupported()
      .then(supported => (supported ? getMessaging(app) : null))
      .catch(() => null);
  }
  return messagingPromise;
}

/* ---------- helper ---------- */
/** Keep ID-tokens in memory; session lives in HttpOnly cookie. */
export async function forceInMemorySession() {
  await setPersistence(auth, browserSessionPersistence); // or .NONE for single-tab mode
}
